'use client';

import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import { useEffect, useRef, useState } from 'react';

const NotFoundAnim = () => {
  const anim = useRef<LottieRefCurrentProps | null>(null);
  const [loadedImage, setLoadedImage] = useState(false);
  const [animation, setAnimation] = useState(null);

  useEffect(() => {
    const fetchAnimation = async () => {
      try {
        const response = await fetch(
          '/static/animations/notFoundPageAnimation.json'
        );
        const data = await response.json();
        setAnimation(data);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    };

    fetchAnimation();
  }, []);

  useEffect(() => {
    if (loadedImage && anim) {
      anim.current?.play();
    }
  }, [loadedImage]);

  return (
    <Lottie
      lottieRef={anim}
      animationData={animation}
      onLoadedImages={() => setLoadedImage(true)}
      loop={false}
    />
  );
};

export default NotFoundAnim;
